import { Helmet } from "react-helmet-async";

export const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = "website"
}) => {
  const siteName = "ekvalleys.com";
  const defaultDescription = "Find every business, service, and experience in the East Kootenay, BC. Local directory featuring Cranbrook, Fernie, Invermere, Golden, Kimberley, and 23 towns.";
  const defaultImage = "https://images.unsplash.com/photo-1626816894318-422017eddfa6?w=1200&q=80";
  
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | East Kootenay Business Directory`;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const metaUrl = url || "https://ekvalleys.com";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};

export default SEO;
